/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ConcurrencyInputs */

const en_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concurrency`)
};

const ar_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوازي`)
};

const bn_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কনকারেন্সি`)
};

const de_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parallelität`)
};

const es_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simultaneidad`)
};

const fr_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concurrence`)
};

const pt_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simultaneidade`)
};

const zh_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`并发`)
};

const tr_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eşzamanlılık`)
};

const ru_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параллелизм`)
};

const pl_svchip_concurrency = /** @type {(inputs: Svchip_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Współbieżność`)
};

/**
* | output |
* | --- |
* | "Concurrency" |
*
* @param {Svchip_ConcurrencyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_concurrency = /** @type {((inputs?: Svchip_ConcurrencyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ConcurrencyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_concurrency(inputs)
	if (locale === "bn") return bn_svchip_concurrency(inputs)
	if (locale === "de") return de_svchip_concurrency(inputs)
	if (locale === "es") return es_svchip_concurrency(inputs)
	if (locale === "fr") return fr_svchip_concurrency(inputs)
	if (locale === "pt") return pt_svchip_concurrency(inputs)
	if (locale === "zh") return zh_svchip_concurrency(inputs)
	if (locale === "tr") return tr_svchip_concurrency(inputs)
	if (locale === "ru") return ru_svchip_concurrency(inputs)
	if (locale === "pl") return pl_svchip_concurrency(inputs)
	return en_svchip_concurrency(inputs)
});